import { render } from "./UserAdministratorButton.vue?vue&type=template&id=7bf6a0e6&scoped=true"
import script from "./UserAdministratorButton.vue?vue&type=script&lang=js"
export * from "./UserAdministratorButton.vue?vue&type=script&lang=js"

import "./UserAdministratorButton.vue?vue&type=style&index=0&id=7bf6a0e6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf6a0e6"]])

export default __exports__